"use strict";
import CarrierService from "../services/carrier_service";
import Account from "../api/account";
import { Tooltip, TooltipDirection, TooltipLocation } from "./ui/v3/tooltip";
var CarrierName = React.createClass({
  propTypes: {
    carrierID: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number
    ]),
    multiple: React.PropTypes.bool,
    includeExternalVendorId: React.PropTypes.bool,
    v3ReskinEnabled: React.PropTypes.bool,
    carrierInvoices: React.PropTypes.array
  },
  getInitialState: function() {
    return {
      carrier: { name: "Loading " + Account.carrierTerm() + " Name..." }
    };
  },
  componentWillMount: function() {
    this.updateCarrier(this.props);
  },
  componentWillReceiveProps: function(newProps) {
    if (newProps.carrierID !== this.props.carrierID) {
      this.updateCarrier(newProps);
    }
  },
  updateCarrier: function(props) {
    var component = this;
    component.setState({ carrier: { name: "Loading " + Account.carrierTerm() + " Name..." } });
    CarrierService.carrierService.carrierWithId(props.carrierID).then((carrier) => {
      if (component.isMounted()) {
        component.setState({ carrier });
      }
    }).catch(console.error);
  },
  carrierName: function() {
    let name = this.state.carrier.name;
    if (this.shouldIncludeExternalVendorId()) {
      name += " - ";
      name += this.state.carrier.external_vendor_id;
    }
    if (this.props.displayNoBuy && this.state.carrier.data && this.state.carrier.data["no_buy"]) {
      name = /* @__PURE__ */ React.createElement(
        "span",
        {
          "data-tooltip": true,
          "aria-haspopup": "true",
          title: "Client marked Do Not Allow Purchases"
        },
        /* @__PURE__ */ React.createElement("i", { className: "fi-alert alert" }),
        " ",
        name,
        " "
      );
    }
    return name;
  },
  shouldIncludeExternalVendorId: function() {
    return this.state.carrier.external_vendor_id && Auth._currentUser.account.factor_account && this.props.includeExternalVendorId;
  },
  render: function() {
    if (this.props.v3ReskinEnabled) {
      return this.renderV3Reskin();
    }
    if (this.props.multiple) {
      return /* @__PURE__ */ React.createElement("span", null, "Multiple ", Account.carrierTerm(), "s");
    }
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("span", null, this.props.carrierNamePrefix, this.carrierName(), this.props.carrierNameSuffix), this.possibleAccountExecName());
  },
  renderV3Reskin: function() {
    if (this.props.multiple) {
      const carrierNames = (this.props.carrierInvoices || []).map((carrierInvoice) => {
        const carrier = CarrierService.carrierService.getCarrierOrUnknown(carrierInvoice.carrier_id);
        return carrier.name;
      });
      if (carrierNames.length < 3) {
        const content = carrierNames.map(
          (carrierName, i) => /* @__PURE__ */ React.createElement("span", { key: carrierName }, carrierName, i == 0 ? ", " : "")
        );
        return /* @__PURE__ */ React.createElement("div", null, content);
      } else {
        const tooltipContent = carrierNames.map((carrierName) => {
          return /* @__PURE__ */ React.createElement("div", { style: { whiteSpace: "nowrap" }, key: carrierName }, `${carrierName}`);
        });
        return /* @__PURE__ */ React.createElement(
          Tooltip,
          {
            content: /* @__PURE__ */ React.createElement("span", { style: { textDecoration: "underline", textDecorationStyle: "dotted" } }, "Multiple"),
            tooltipContent,
            direction: TooltipDirection.Right,
            location: TooltipLocation.Hidden
          }
        );
      }
    } else {
      return /* @__PURE__ */ React.createElement("span", null, this.state.carrier.name);
    }
  },
  possibleAccountExecName: function() {
    const id = this.state.carrier.id;
    if (this.props.displayAccountExec && id) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, "Account Exec:\xA0"), /* @__PURE__ */ React.createElement("span", null, this.accountExecName()));
    }
  },
  accountExecName: function() {
    var exec = this.state.carrier.account_exec;
    if (!exec) {
      exec = "Not set for " + Account.carrierTermLower();
    }
    return /* @__PURE__ */ React.createElement("span", null, exec);
  }
});
export default CarrierName;
